import { Star, Facebook, ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/lib/Reveal";
import { REVIEWS, BUSINESS } from "@/lib/data";

export const Reviews = () => {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 lg:py-28 bg-[#0C0C0C] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal><SectionLabel>08 / Word on the street</SectionLabel></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white mt-4">
                Rated 5.0 by 26 customers.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <div className="flex flex-wrap items-center gap-x-7 gap-y-3">
              <a href={BUSINESS.google} target="_blank" rel="noopener noreferrer" data-testid="google-reviews-link" className="flex items-center gap-1.5 group">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-torch-amber text-torch-amber" />
                ))}
                <span className="font-mono text-xs text-neutral-400 ml-2 tracking-wider uppercase group-hover:text-torch transition-colors">5.0 · 26 on Google</span>
              </a>
              <a href={BUSINESS.facebook} target="_blank" rel="noopener noreferrer" data-testid="facebook-rating-badge" className="flex items-center gap-2 group">
                <Facebook className="w-4 h-4 text-torch" />
                <span className="font-mono text-xs text-neutral-400 tracking-wider uppercase group-hover:text-torch transition-colors">4.9 · 48 on Facebook</span>
              </a>
            </div>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-12">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.1} className="h-full">
              <blockquote
                data-testid={`review-card-${i}`}
                className="h-full bg-surface border border-neutral-800 hover:border-torch/50 rounded-sm p-7 transition-colors"
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} className="w-3.5 h-3.5 fill-torch-amber text-torch-amber" />
                  ))}
                </div>
                <p className="text-neutral-300 text-sm leading-relaxed">"{r.text}"</p>
                <footer className="mt-6 pt-4 border-t border-neutral-800 flex items-center justify-between">
                  <span className="font-display font-bold text-white text-sm">{r.name}</span>
                  <span className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase">{r.time} · Google review</span>
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6 border border-neutral-800 rounded-sm p-8 bg-gradient-to-r from-surface to-[#171008]">
            <div>
              <p className="font-display font-bold text-xl text-white">Follow the day-to-day on Facebook</p>
              <p className="text-sm text-neutral-400 mt-1">Job photos, winter tips and seasonal offers — straight from the van.</p>
            </div>
            <div className="flex flex-wrap gap-3 shrink-0">
              <a
                href={BUSINESS.google}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="leave-review-link"
                className="flex items-center gap-3 border border-torch/50 hover:bg-torch/10 text-torch font-display font-bold uppercase tracking-wide px-6 py-3.5 rounded-sm transition-colors"
              >
                <Star className="w-5 h-5" />
                Leave a Google review
              </a>
              <a
                href={BUSINESS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="facebook-link"
                className="group flex items-center gap-3 bg-torch hover:bg-torch-hover text-white font-display font-bold uppercase tracking-wide px-6 py-3.5 rounded-sm transition-all hover:shadow-[0_0_28px_rgba(255,85,0,0.45)]"
              >
                <Facebook className="w-5 h-5" />
                Find us on Facebook
                <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
